import React from 'react'

function BciCrmAI() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        border: "none",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        zIndex: 9999,
      }}
    >
      <iframe
        src="https://pdhanewala.com:4002"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        title="Streamlit App"
      />
    </div>
  );
}

export default BciCrmAI